import { Box, Dialog, DialogContent, IconButton, List, ListItem, ListItemAvatar, ListItemText, Stack, Typography } from '@mui/material'
import { useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'
import { observer } from 'mobx-react-lite'
import StoreGenealogyFilter from './StoreGenealogyFilter'
import styled from '@emotion/styled'
import { ReactComponent as CloseIcon } from './assets/CloseIcon.svg'
import { useNavigate } from 'react-router-dom'
import GenealogyProfilePicture from './GenealogyProfilePicture'
import { get } from 'lodash'
import { runInAction } from 'mobx'

const GenealogyHistoryModal = observer(() => {
    const translate = useTranslate()
    const navigate = useNavigate()

    const handleClose = () => {
        StoreGenealogyFilter.setShowHistoryModal(false)
    }

    const handleSelectCustomer = customerId => {
        StoreGenealogyFilter.setShowHistoryModal(false)
        navigate(`/user/genealogy/${customerId}`)
    }

    const handleRemoveItem = (e, customerId) => {
        e.stopPropagation()
        StoreGenealogyFilter.removeFromHistory(customerId)
    }

    const handleClearAll = () => {
        StoreGenealogyFilter.clearHistory()
        runInAction(() => {
            StoreGenealogyFilter.history = []
        })
    }

    return (
        <Dialog
            open={StoreGenealogyFilter.getShowHistoryModal()}
            onClose={handleClose}
            sx={{
                '& .MuiDialog-paper': {
                    width: '100%',
                    maxWidth: '450px',
                    borderRadius: '8px',
                    maxHeight: '70vh'
                }
            }}>
            <DialogContent sx={{ padding: '0px!important' }}>
                <Stack>
                    {/* Header */}
                    <Stack
                        bgcolor={'#E3E7EC'}
                        padding={'15px 20px'}
                        position={'relative'}
                        justifyContent={'space-between'}
                        alignItems={'center'}
                        direction={'row'}>
                        <Typography fontFamily={'Poppins'} fontSize={'16px'} fontWeight={600} color={'#384250'} textTransform={'uppercase'}>
                            {translate('history')}
                        </Typography>
                        <Box onClick={handleClose} display={'flex'} alignItems={'center'} justifyContent={'center'} sx={{ cursor: 'pointer' }}>
                            <CloseIcon />
                        </Box>
                    </Stack>

                    {/* History List */}
                    <Stack sx={{ maxHeight: '400px', overflowY: 'auto' }}>
                        {StoreGenealogyFilter.getHistory().length === 0 ? (
                            <Stack padding={'40px 20px'} alignItems={'center'} justifyContent={'center'}>
                                <Typography fontFamily={'Poppins'} fontSize={'14px'} fontWeight={400} color={'#9EA9B9'} textAlign={'center'}>
                                    {translate('no_history') || 'No history'}
                                </Typography>
                            </Stack>
                        ) : (
                            <List sx={{ padding: 0 }}>
                                {[...StoreGenealogyFilter.getHistory()].reverse().map((item, index) => {
                                    return (
                                        <HistoryListItem
                                            key={`${item.customerId}-${index}`}
                                            onClick={() => handleSelectCustomer(item.customerId)}
                                            divider={index < StoreGenealogyFilter.getHistory().length - 1}
                                            sx={{ gap: '8px'}}>
                                            <ListItemAvatar>
                                                <GenealogyProfilePicture
                                                    profileRankShort={get(item, 'highestRankShort', '')}
                                                    profilePicture={get(item, 'profilePicture.sizes[0].media', '')}
                                                    isSuspended={get(item, 'isSuspended', false)}
                                                    avatarStyle="circle"
                                                />
                                            </ListItemAvatar>

                                            <ListItemText
                                                primary={
                                                    <Stack direction="row" alignItems="center" gap={1}>
                                                        <Typography
                                                            fontFamily={'Inter, Poppins, NotoSansThai'}
                                                            fontSize={'16px'}
                                                            fontWeight={400}
                                                            color={'rgb(0,0,0,0.87)'}>
                                                            {item.customerName}
                                                        </Typography>
                                                    </Stack>
                                                }
                                                secondary={
                                                    <Stack>
                                                        {item.nativeName && item.nativeName !== item.customerName && (
                                                            <Typography
                                                                fontFamily={'Inter, Poppins, NotoSansThai'}
                                                                fontSize={'16px'}
                                                                fontWeight={400}
                                                                color={'rgb(0,0,0,0.87)'}>
                                                                {item.nativeName}
                                                            </Typography>
                                                        )}
                                                    </Stack>
                                                }
                                            />
                                        </HistoryListItem>
                                    )
                                })}
                            </List>
                        )}
                    </Stack>

                    {/* Footer with Clear All */}
                    {StoreGenealogyFilter.getHistory().length > 0 && (
                        <Stack borderTop={'1px solid #E3E7EC'} padding={'15px 20px'} alignItems={'center'} justifyContent={'center'}>
                            <ClearAllButton onClick={handleClearAll}>
                                <Typography fontFamily={'Poppins'} fontSize={'14px'} fontWeight={500} color={'rgb(34, 170, 236)'}>
                                    {translate('clear_all') || 'Clear All'}
                                </Typography>
                            </ClearAllButton>
                        </Stack>
                    )}
                </Stack>
            </DialogContent>
        </Dialog>
    )
})

const HistoryListItem = styled(ListItem)`
    padding: 12px 20px;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: #f5f7fa;
    }
`

const RemoveButton = styled(IconButton)`
    opacity: 0.5;
    transition: opacity 0.2s ease;
    padding: 4px;

    &:hover {
        opacity: 1;
        background-color: rgba(220, 38, 38, 0.1);
    }

    svg path {
        stroke: #dc2626;
    }
`

const ClearAllButton = styled(Box)`
    cursor: pointer;
    padding: 8px 16px;
    border-radius: 6px;
    transition: background-color 0.2s ease;
`

export default GenealogyHistoryModal
